import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityBasicText } from './basicText';
import { form, SanityForm } from './form';
import { SanityFormConfirmation } from './formConfirmation';
import { link } from './link';
import { logoMarquee, SanityLogoMarquee } from './logoMarquee';
import { media, SanityMedia } from './media';
import { richText } from './richText';
import { SanitySocialProof, socialProof } from './socialProof';

export const SanityEventHero = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('eventHero'),
  _key: z.string(),
  theme: z.enum(['purple', 'charcoal', 'white']).optional().nullable(),
  backgroundPattern: z.string().optional().nullable(),
  headline: z.string(),
  bodyCopy: SanityBasicText,
  formMedia: SanityMedia,
  socialProof: SanitySocialProof,
  logoMarquee: SanityLogoMarquee.optional().nullable(),
  form: SanityForm.nullable(),
  formConfirmation: SanityFormConfirmation.nullable(),
  /** Injected from the parent event document. */
  isPast: z.boolean(),
});

export type SanityEventHero = z.infer<typeof SanityEventHero>;

export const eventHero = groq`{
  _type,
  _key,
  theme,
  'backgroundPattern': background,
  headline,
  "bodyCopy": bodyCopy[] ${richText},
  "formMedia": formMedia[0] ${media},
  "socialProof": socialProof ${socialProof},
  "form": form-> ${form},
  // Must scope into formConfirmation — a bare { bodyCopy } here would pick up
  // the hero's portable text field (same bug as the prior select branch).
  "formConfirmation": select(
    defined(formConfirmation.bodyCopy) => formConfirmation {
      headline,
      bodyCopy,
      cta[0] ${link},
    },
    null
  ),
  "logoMarquee": logoMarquee->sections[0] ${logoMarquee},
  'isPast': coalesce(^.endDate, ^.startDate) < now(),
}`;
